(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  /* Fixed bottom tab bar (phones). Its only job is to reserve page-bottom space
     equal to the (safe-area-inclusive) bar height so the fixed bar never covers
     content. The reserve goes on <html> too, because fixed overlays owned by
     other components — the cart drawer — need to read it. */
  class EbMobileNav extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.eb-mnav__bar');
      this.onResize = this.reserveSpace.bind(this);
      window.addEventListener('resize', this.onResize);
      window.addEventListener('orientationchange', this.onResize);
      this.reserveSpace();
      this.initSearch();
    }

    /* Search tab: opens the header's search. If the header has scrolled out of
       view (non-sticky header), glide back to the top first so the field shows. */
    initSearch() {
      var btn = this.querySelector('[data-eb-mnav-search]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var header = document.querySelector('eb-header');
        if (!header || typeof header.openSearch !== 'function') return;
        var visible = header.getBoundingClientRect().bottom > 0;
        if (!visible) window.scrollTo({ top: 0, behavior: 'smooth' });
        window.setTimeout(function () { header.openSearch(); }, visible ? 0 : 350);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('orientationchange', this.onResize);
      this.clearReserve();
    }

    reserveSpace() {
      if (!this.bar) return;
      if (!window.matchMedia(MOBILE).matches) {
        this.clearReserve();
        return;
      }
      var h = Math.round(this.bar.getBoundingClientRect().height);
      if (!h) return;
      document.body.style.paddingBottom = h + 'px';
      document.documentElement.style.setProperty('--eb-mnav-reserve', h + 'px');
      document.documentElement.classList.add('eb-mnav-on');
    }

    clearReserve() {
      document.body.style.paddingBottom = '';
      document.documentElement.style.removeProperty('--eb-mnav-reserve');
      document.documentElement.classList.remove('eb-mnav-on');
    }
  }

  if (!customElements.get('eb-mobile-nav')) {
    customElements.define('eb-mobile-nav', EbMobileNav);
  }
})();
